// extracted by mini-css-extract-plugin
export default {"input":"Contacts_input__DETFj"};